<template>
    <b-card class="bg-default-card no-padding" v-if="relation">
        <b-tabs card>
            <b-tab :title="uLang('app.entity_details', { entity: lang('app.relation') })" active>
                <div class="row mb-4">
                    <div class="col-md-4" v-if="imagePath">
                        <div class="text-center">
                            <img class="relation_image" :src="imagePath"/>
                        </div>
                    </div>

                    <div :class="{'col-md-8': imagePath !== null,'col-md-12': imagePath === null }">
                        <div class="inner">
                            <div v-if="($can('update-relations') || $can('update-relations-basic')) && !showOnly"
                                 class="mb-3">
                                <router-link :to="{ name: 'admin.relations.edit',  params: { id: this.id }}"
                                             class="btn btn-brand"
                                >
                                    {{ uLang("app.edit_type", {type: lang("app.relation")}) }}
                                </router-link>

                                <router-link
                                    :to="{ name: 'admin.organisations.create.candidate',  params: { type: relation.type.id, relationId: relation.id }}"
                                    v-if="$can('create-organisations')"
                                    class="btn btn-brand ml-4"
                                >
                                    {{ uLang("app.create_organisation_for_relation") }}
                                </router-link>

                                <client-candidates-export-button
                                    v-if="relation.type.system_name === 'client' && isIdEmployee"
                                    class="float-right ml-2"
                                    route-name="relations.client-candidates.export"
                                    :route-params="{ relation: id }"
                                />

                                <router-link
                                    :to="{  name: 'admin.relations.view.client-candidates', params: { id: this.id }}"
                                    v-if="relation.type.system_name === 'client' && !isCoach"
                                    class="btn btn-brand float-right"
                                >
                                    {{ uLang("app.trajectory_contact_candidates", { type: lang("app.relation") }) }}
                                </router-link>

                                <router-link
                                    :to="{ name: 'admin.relations.view.candidates', params: { id: this.id }}"
                                    v-else-if="relation.type.system_name === 'coach'"
                                    class="btn btn-brand float-right"
                                >
                                    {{ uLang("app.trajectory_manager_candidates", { type: lang("app.relation") }) }}
                                </router-link>
                            </div>
                            <relation-info-table :relation="relation"/>
                        </div>
                    </div>
                </div>

                <addresses-display
                    v-if="!$hasType('client')"
                    entity="relation"
                    :showOnly="showOnly"
                    :id="id"
                    :addresses="relation.addresses"
                    ref="addressDisplay"
                />

                <!-- Only show row if the user has permission to see any of the tabs. -->
                <div class="row" v-if="canViewTabs">
                    <div class="col-md-12 tabs-show-area">
                        <b-card no-body class="mt-3">
                            <user-tabs :relation="relation" :showOnly="showOnly"/>
                        </b-card>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
    import {
        LocationsTab,
        CoachTrajectoryEnrolmentsTab,
        UserTabs,
    } from "~/components/tabs";
    import SuccessAlert from "~/Swals/SuccessAlert";
    import AddressesDisplay from "~/components/addresses/display";
    import RelationInfoTable from "~/components/relations/basic-info-table";
    import ClientCandidatesExportButton from "~/components/buttons/client-candidates-export-button";
    import { mapGetters } from "vuex";

    export default {
        name: "show",
        components: {
            UserTabs,
            LocationsTab,
            AddressesDisplay,
            RelationInfoTable,
            CoachTrajectoryEnrolmentsTab,
            ClientCandidatesExportButton,
        },
        props: {
            id: {
                required: true,
            },
        },
        data: function () {
            return {
                relation: null,
            };
        },
        created: function () {
            this.retrieveRelation();
        },
        computed: {
            ...mapGetters([`authUser`]),
            imagePath() {
                if (!this.relation || !this.relation.image_id) {
                    return null;
                }

                return route("resource.files.show", { file: this.relation.image_id });
            },
            canViewTabs() {
                return (
                    (
                        (
                            this.relation.type.system_name === "candidate" &&
                            $can("view-trajectory-enrolments")
                        ) ||
                        this.relation.type.system_name === "coach" ||
                        $can("index-files") ||
                        $can("view-intern-logs") ||
                        $can("view-report-logs") ||
                        $can("view-candidate-logs")
                    ) &&
                    !(this.relation.type.system_name === "coach" &&
                        $hasType("client"))
                );
            },
            isCoach() {
                return this.authUser.type.system_name === "coach";
            },
            isIdEmployee() {
                return this.authUser.type.system_name === "id_employee";
            },
            showOnly() {
                return this.$route.fullPath.includes('my-profile')
            },
        },
        methods: {
            async retrieveRelation() {
                const { data } = await window.axios.get("/api/admin/relations/" + this.id);
                this.relation = data;
                if (this.relation.type.system_name === undefined) {
                    this.relation.type.system_name = null;
                }
            },
            async sendPasswordResetRequest() {
                const { data } = await window.axios.get("/api/admin/relations/passwordreset/" + this.id);
                new SuccessAlert({ text: this.uLang("app.reset_link_sended") }).show();
            },
        }
    };
</script>

<style lang="css" scoped>
    .relation_image {
        max-width: 100%;
        max-height: 200px;
        border-radius: 50%;
    }
    .detail-buttons {
        margin-bottom: 15px;
        float: right;
    }
    .add_address {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .action_icon {
        cursor: pointer;
        margin-right: 5px;
    }
    .address_block a {
        margin-right: 10px;
    }
</style>
